var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{attrs:{"padding":""}},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Rechtliches")]),_c('pre',[_vm._v("[In Arbeit]")])])])}
var staticRenderFns = []

export { render, staticRenderFns }